module.exports = __webpack_public_path__ + "static/media/icon-close.e894538f.svg";